import React from 'react';
import Consents, { ConsentsProps } from './components/consents.js';
import Delete from './components/delete.js';
import SchibstedPrivacySettings, {
    SchibstedPrivacySettingsPageProps,
} from './components/schibsted-privacy-settings.js';
import { ProfileProps } from './components/profile.js';
import { ConsentContextProvider } from './consent-context.js';
import { SchibstedPrivacySettingsContextProvider } from './schibsted-privacy-settings-context.js';
import {
    TranslationContextProvider,
    TranslationContextType,
} from './translation-context.js';
import { I18n } from '@lingui/core';

export type PageProps = ConsentsProps &
    SchibstedPrivacySettingsPageProps &
    ProfileProps &
    TranslationContextType & {
        hmacToken: string;
        privacySettings?: PrivacySettings;
        brandPrivacySettings?: PrivacySettings;
        environmentId?: string;
        brand: string;
        locale: string;
    };

export type PageAndI18nProps = PageProps & {
    i18n: I18n;
};

export default function Page(props: PageAndI18nProps): React.ReactElement {
    return (
        <TranslationContextProvider i18n={props.i18n} texts={props.texts}>
            <ConsentContextProvider
                baseUrl={props.baseUrl}
                givenConsents={props.givenConsents}
                consentUser={props.consentUser}
                hmacToken={props.hmacToken}
                i18n={props.i18n}
            >
                {props.brand === 'FINN' && <Consents {...props}></Consents>}
                <SchibstedPrivacySettingsContextProvider
                    baseUrl={props.baseUrl}
                    consentUser={props.consentUser}
                    hmacToken={props.hmacToken}
                    privacySettings={props.privacySettings}
                    brandPrivacySettings={props.brandPrivacySettings}
                    environmentId={props.environmentId}
                    i18n={props.i18n}
                    brand={props.brand}
                >
                    <SchibstedPrivacySettings {...props} />
                </SchibstedPrivacySettingsContextProvider>
                {/*TODO move to it's own component?*/}
                {props.consentUser.isLoggedIn && (
                    <div className="md:grid md:grid-cols-3">
                        <div className="md:col-span-2">
                            <Delete {...props} />
                        </div>
                    </div>
                )}
            </ConsentContextProvider>
        </TranslationContextProvider>
    );
}
